/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";
import { generateApiUrl, generateFullName } from "@/shared/utils";

export const getDashboardReportTypes = async (queryString) => {
  try {
    const url =
      generateApiUrl(["report", "dashboard_report_type"]) + queryString;
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const companyInfo = pathOr(null, ["company_info"], data);

    const algorithmNames = pathOr([], ["algorithm_name"], data);
    return {
      resAllowTabs: ["tab-one", "tab-two", ...algorithmNames],
      resCompanyName: pathOr("", ["company_name"], companyInfo),
      resCompanyLogo: pathOr("", ["logo_address"], companyInfo),
    };
  } catch (error) {
    throw error;
  }
};
export const getSummaryParvandeh = async (queryString) => {
  try {
    const url = generateApiUrl(["report", "summary_parvandeh"]) + queryString;
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const items = data.map((item) => {
      const reports = pathOr([], ["reports"], item);
      const parvandeh = pathOr(null, ["parvandeh"], item);
      const person = pathOr(null, ["person"], parvandeh);
      return {
        tabDescription: pathOr("", ["description"], item),
        personCode: pathOr(null, ["code"], person),
        image: pathOr("", ["image_address"], person),
        fullName: generateFullName(person),
        parvandehNumber: pathOr(null, ["parvandeh_number"], parvandeh),
        parvandehCode: pathOr(null, ["code"], parvandeh),
        termCaption: pathOr("", ["term", "caption"], parvandeh),
        companyName: pathOr("", ["term", "company", "caption"], parvandeh),
        educationField: pathOr("", ["educations", "education_field"], item),
        educationGrade: pathOr("", ["educations", "grade", "caption"], item),
        jobPosition: pathOr("", ["jobs", "position"], item),
        jobLevel: pathOr("", ["jobs", "job_level", "caption"], item),
        jobCategory: pathOr("", ["jobs", "job_category"], item),
        performance: pathOr(null, ["performance"], item),
        reports: [
          ...reports.map((report) => {
            return {
              caption: pathOr("", ["caption"], report),
              downloadLink: pathOr(null, ["download_link"], report),
              suffix: pathOr(null, ["ext"], report),
              previewImage: pathOr(null, ["preview_image"], report),
              requestType: pathOr("file", ["request_type"], report),
            };
          }),
        ],
      };
    });
    return { items };
  } catch (error) {
    throw error;
  }
};
export const getCompetencyWashupScores = async (queryString) => {
  try {
    const url =
      generateApiUrl(["report", "competency_washup_scores"]) + queryString;
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const items = data.map((item) => {
      // generate competencies for washup table
      let competencies = pathOr([], ["competencies"], item);
      competencies = competencies.map((item) => {
        return {
          id: pathOr(null, ["id"], item),
          overviewId: pathOr(null, ["overview_id"], item),
          centerExecuteCaseId: pathOr(null, ["center_execute_case_id"], item),
          name: pathOr(null, ["name"], item),
          score: pathOr(null, ["score"], item),
          scoreAvg: pathOr(null, ["score_avg"], item),
          average: pathOr(null, ["average"], item),
          overall: pathOr(null, ["overall"], item),
          strengthAndDevelopment: pathOr(
            null,
            ["strength_development_area"],
            item
          ),
        };
      });
      // generate exercises for washup table
      let exercises = pathOr([], ["exercises"], item);
      exercises = exercises.map((item) => {
        return {
          id: pathOr(null, ["id"], item),
          overviewId: pathOr(null, ["overview_id"], item),
          centerExecuteCaseId: pathOr(null, ["center_execute_case_id"], item),
          name: pathOr(null, ["name"], item),
          assessor: pathOr(null, ["assessor"], item),
          score: pathOr(null, ["score"], item),
          overall: pathOr(null, ["overall"], item),
          strengthAndDevelopment: pathOr(
            null,
            ["strength_development_area"],
            item
          ),
        };
      });

      const itemsData = pathOr([], ["items"], item);
      const parvandeh = pathOr(null, ["parvandeh"], item);
      const person = pathOr(null, ["person"], parvandeh);
      return {
        // competencies: pathOr([], ["competencies"], item),
        competencies,
        exercises,
        effectOfPositionOnSuccess: pathOr(
          [],
          ["effect_of_position_on_success"],
          item
        ),
        overall: pathOr(null, ["overall"], item),
        forecast: pathOr(null, ["forecast"], item),
        centerExecuteId: pathOr(null, ["center_execute_id"], item),
        personCode: pathOr(null, ["code"], person),
        image: pathOr("", ["image_address"], person),
        fullName: generateFullName(person),
        parvandehNumber: pathOr(null, ["parvandeh_number"], parvandeh),
        parvandehCode: pathOr(null, ["code"], parvandeh),
        termCaption: pathOr("", ["term", "caption"], parvandeh),
        companyName: pathOr("", ["term", "company", "caption"], parvandeh),
        // generate items
        items: itemsData.map((item) => {
          const competencyId = pathOr(null, ["competency_id"], item);
          const competency = competencies.find(({ id }) => id === competencyId);

          const exerciseId = pathOr(null, ["exercise_id"], item);
          const exercise = exercises.find(({ id }) => id === exerciseId);

          return {
            id: pathOr(null, ["id"], item),
            caseId: pathOr(null, ["case_id"], item),
            competencyId: pathOr(null, ["competency_id"], item),
            exerciseId: pathOr(null, ["exercise_id"], item),
            score: pathOr(0, ["score"], item),
            recommendedScore: pathOr(0, ["score_suggest"], item),
            evidenceLogCount: pathOr(0, ["evidence_log_count"], item),
            finalDescription: pathOr("", ["final_description"], item),
            description: pathOr("", ["description"], item),
            isAbsent: pathOr(false, ["is_absent"], item),
            isChangeFinalDescription: pathOr(
              false,
              ["is_change_final_description"],
              item
            ),
            competency: competency || null,
            exercise: exercise || null,
          };
        }),
      };
    });
    return { items };
  } catch (error) {
    throw error;
  }
};
export const getDashboardReport = async (queryString) => {
  try {
    const url = generateApiUrl(["report", "dashboard_report"]) + queryString;
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const avgParentData = pathOr(
      null,
      ["data", "other", "avg", "parent"],
      response
    );
    const avgChildData = pathOr(
      null,
      ["data", "other", "avg", "child"],
      response
    );
    const items = data.map((item) => {
      const parent = pathOr(null, ["parent"], item);
      const child = pathOr([], ["child"], item);
      const children = [];
      for (const [, item] of Object.entries(child)) {
        children.push(item);
      }
      const parvandeh = pathOr(null, ["parvandeh"], item);
      const person = pathOr(null, ["person"], parvandeh);
      return {
        parent,
        children,
        personCode: pathOr(null, ["code"], person),
        image: pathOr("", ["image_address"], person),
        fullName: generateFullName(person),
        parvandehNumber: pathOr(null, ["parvandeh_number"], parvandeh),
        parvandehCode: pathOr(null, ["code"], parvandeh),
        termCaption: pathOr("", ["term", "caption"], parvandeh),
        companyName: pathOr("", ["term", "company", "caption"], parvandeh),
      };
    });

    return { items, avgParentData, avgChildData };
  } catch (error) {
    throw error;
  }
};
export const summaryParvandehExport = async (queryString) => {
  try {
    const url =
      generateApiUrl(["report", "summaryParvandehExport"]) + queryString;
    const response = await httpService.get(url);
    const message = pathOr("", ["data", "message"], response);
    const link = pathOr(null, ["data", "data"], response);

    return { message, link };
  } catch (error) {
    throw error;
  }
};
